import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1251c84e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "project-list"
};
const _hoisted_2 = {
  style: {
    "height": "180px",
    "overflow": "hidden"
  }
};
const _hoisted_3 = ["src"];
import { SysDictDataControllerService } from "../../../generated";
import { ref } from "vue";
import DictTag from "@/components/tool/DictTag.vue";
import { useRouter } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseDesignList',
  props: {
    courseDesignList: {
      default: () => []
    }
  },
  setup(__props) {
    const router = useRouter();
    const dicType = ref("project_type");
    const dictList = ref([]);
    const getImageUrl = item => {
      return item.imageUrl === null || item.imageUrl == '' ? require("@/assets/default-project-image.png") : item.imageUrl;
    };
    const props = __props;
    //获取字典数据
    SysDictDataControllerService.dictTypeUsingGet(dicType.value).then(res => {
      if (res.code === 200) {
        dictList.value = res.data;
      }
    });
    const clickCard = id => {
      router.push(`/business/courseDesign/detail/${id}`);
    };
    return (_ctx, _cache) => {
      const _component_a_card_meta = _resolveComponent("a-card-meta");
      const _component_a_card = _resolveComponent("a-card");
      const _component_a_list_item = _resolveComponent("a-list-item");
      const _component_a_list = _resolveComponent("a-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_list, {
        grid: {
          gutter: 16,
          xs: 1,
          sm: 2,
          md: 2,
          lg: 4,
          xl: 4,
          xxl: 4
        },
        "item-layout": "horizontal",
        "data-source": props.courseDesignList
      }, {
        renderItem: _withCtx(({
          item
        }) => [_createVNode(_component_a_list_item, {
          style: {
            "display": "flex",
            "justify-content": "center",
            "align-items": "center",
            "padding": "10px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_card, {
            hoverable: "",
            onClick: $event => clickCard(item.id),
            style: {
              "width": "300px",
              "height": "300px",
              "box-shadow": "0 2px 4px rgba(0,0,0,.14)"
            }
          }, {
            cover: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
              alt: "xiaoniu",
              src: getImageUrl(item),
              style: {
                "width": "100%",
                "height": "100%"
              },
              class: "logo"
            }, null, 8, _hoisted_3)])]),
            default: _withCtx(() => [dictList.value.length ? (_openBlock(), _createBlock(DictTag, {
              key: 0,
              style: {
                "margin-bottom": "10px"
              },
              "dict-list": dictList.value,
              "dic-value": item.type
            }, null, 8, ["dict-list", "dic-value"])) : _createCommentVNode("", true), _createVNode(_component_a_card_meta, null, {
              description: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 2
        }, 1024)]),
        _: 1
      }, 8, ["data-source"])]);
    };
  }
});